import { render, staticRenderFns } from "./ListaMultimidia.vue?vue&type=template&id=1b11a05d"
import script from "./ListaMultimidia.vue?vue&type=script&lang=js"
export * from "./ListaMultimidia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports